import { PortalType } from '@studyportals/domain-client';
import { ParameterType } from '@/study-search/enums';
import { PortalDefinitionHelper } from '../../definition';

import { TitleBase } from './TitleBase';

export default class TitleDisciplineAttendance extends TitleBase {
	private readonly portalDefinition = new PortalDefinitionHelper().getPortalDefinition(PortalType.DISTANCE_LEARNING);
	private disciplineValue: string;
	private attendanceValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.attendanceValue = this.getFilterValue(ParameterType.DELIVERY_METHOD);
		const countryContinentFilter = this.filters.filter(
			(_) => _.values.length > 1 && (_.type === ParameterType.COUNTRY || _.type === ParameterType.CONTINENT),
		);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD) &&
			countryContinentFilter.length === 0
		);
	}

	protected getPageTitle(): string {
		if (this.titlePortalType === this.portalDefinition.titlePortalType) {
			return `${this.titlePortalType} in ${this.disciplineValue}`;
		}

		return `${this.attendanceValue} ${this.titlePortalType} in ${this.disciplineValue}`;
	}

	protected getMetaDescription(): string {
		if (this.titlePortalType === this.portalDefinition.titlePortalType) {
			return this.buildMetaDescription(`${this.titlePortalType} in the field of ${this.disciplineValue}`, ' worldwide');
		}

		return this.buildMetaDescription(
			`${this.attendanceValue.toLowerCase()} ${this.titlePortalType} in the field of ${this.disciplineValue}`,
			' worldwide',
		);
	}
}
